import { gql } from "@apollo/client";

export const GET_TOP_5_TIPPERS_BY_AMOUNT = gql`
  query getTop5TippersByAmount($tipAmount: TipAmountInput!, $range: String!) {
    getTop5TippersByAmount(tipAmount: $tipAmount, range: $range) {
      name
      topTippers {
        username
        count
      }
    }
  }
`;

export const GET_TIP_STATISTICS = gql`
  query getTipStatistics($range: String!) {
    getTipStatistics(range: $range) {
      totalTips
      totalTokens
      averageTip
      medianTip
      biggestTip
      smallestTip
      uniqueTippers
      mostCommonTipAmount {
        amount
        count
      }
      tipsByDay {
        date
        count
        tokens
      }
      tipsByHour {
        hour
        count
        tokens
      }
      topTipAmounts {
        amount
        count
      }
    }
  }
`;
